import { render } from "./CollectionCardApe.vue?vue&type=template&id=3a3b873c"
import script from "./CollectionCardApe.vue?vue&type=script&lang=js"
export * from "./CollectionCardApe.vue?vue&type=script&lang=js"

import "./CollectionCardApe.vue?vue&type=style&index=0&id=3a3b873c&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__